@import "@SeemplicityDev/shared/src/design-system/styles/constants.scss";

.user-avatar {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  border-style: solid;
  border-color: var(--main-background-color);

  &.is-xs {
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
    padding-top: 2px;
    border-width: 1px;
    @include caption-typography;
  }

  &.is-small {
    width: 24px;
    height: 24px;
    flex: 0 0 24px;
    padding-top: 2px;
    border-width: 1px;
    font-size: var(--font-size-xxs);
    font-weight: 500;
  }

  &.is-medium {
    width: 30px;
    height: 30px;
    flex: 0 0 30px;
    font-weight: 600;
    border-width: 2px;
    font-size: var(--font-size-s);
    padding-top: 3px;
    padding-left: 1px;
  }
}
